import { HOST } from "../api/endpoints";

/** Local banner uploads are stored on the dev backend, not staging BASE_URL. */
export function resolveBannerUrl(url: string | undefined): string | undefined {
  if (!url?.includes("/local-uploads/")) {
    return url;
  }

  const backendOrigin = (HOST || "http://localhost:8080").replace(/\/$/, "");
  const path = url.slice(url.indexOf("/local-uploads/"));
  return `${backendOrigin}${path}`;
}
